import request from '@/utils/request';

export function getList(data) {
  return request({
    url: '/Tx_Quot_Supply_Details/load',
    method: 'post',
    data
  });
}

export function loadForRole(roleId) {
  return request({
    url: '/Tx_Quot_Supply_Details/loadForRole',
    method: 'get',
    params: { appId: '', firstId: roleId }
  });
}

export function add(data) {
  return request({
    url: '/Tx_Quot_Supply_Details/add',
    method: 'post',
    data
  });
}

export function update(data) {
  return request({
    url: '/Tx_Quot_Supply_Details/update',
    method: 'post',
    data
  });
}

export function del(data) {
  return request({
    url: '/Tx_Quot_Supply_Details/delete',
    method: 'post',
    data
  });
}

export function get(id) {
  return request({
    url: '/Tx_Quot_Supply_Details/Get',
    method: 'get',
    params: { id: id }
  });
}

export function getloadfile(data) {
  return request({
    url: '/Tx_Quot_Supply_Details/GetLoadFile',
    method: 'post',
    responseType: 'arraybuffer',
    data
  });
}
